import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';

export type PopUpType = 'Negative' | 'Positive' | 'Neutral' | 'Warning';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss'],
})
export class DeletePopupComponent {
  btnColor: string;
  borderColor: string;

  constructor(
    public dialogRef: MatDialogRef<DeletePopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      header: string;
      message: string;
      buttonText: string;
      imgSrc: string;
      imgHide: boolean;
      subText: string;
      popUpType?: PopUpType;
      cancelText?: string;
    },
  ) {
    this.btnColor = 'btn-red';
    this.borderColor = environment.name == 'bucs' ? '#f24646' : '#DD4848';
    if (data.popUpType) {
      //==='Reactivate' || data.buttonText==='Continue' || data.buttonText==="Publish" || data.buttonText==="Unarchive" || data.buttonText === 'Enable' || data.buttonText === 'Unlock' || data.buttonText === 'Yes'
      this.btnColor = 'btn-green';
      this.borderColor = environment.name === 'bucs' ? '#2FAC61' : '#1ed761';
    }
    if (data.popUpType == 'Neutral') {
      this.btnColor = 'btn-yellow';
      this.borderColor = environment.name === 'bucs' ? '#F0B220' : '#1ed761';
    }
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
